"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeSnapshotItems = normalizeSnapshotItems;
exports.buildCheckoutSessionEventResponse = buildCheckoutSessionEventResponse;
function normalizeOptionalString(value) {
    return typeof value === "string" ? value : undefined;
}
function normalizeOptionalNumber(value) {
    if (value === null) {
        return null;
    }
    return typeof value === "number" && Number.isFinite(value) ? value : undefined;
}
function normalizeOptionalInteger(value) {
    return typeof value === "number" && Number.isFinite(value) ? Math.trunc(value) : undefined;
}
function normalizeStripeExpandableId(value) {
    if (typeof value === "string") {
        return value;
    }
    if (typeof value === "object" && value !== null) {
        const id = value.id;
        return typeof id === "string" ? id : undefined;
    }
    return undefined;
}
function setStringField(target, key, value) {
    const normalized = normalizeOptionalString(value);
    if (normalized !== undefined) {
        target[key] = normalized;
    }
}
function setNumberField(target, key, value) {
    const normalized = normalizeOptionalNumber(value);
    if (normalized !== undefined) {
        target[key] = normalized;
    }
}
function setIdField(target, key, value) {
    const normalized = normalizeStripeExpandableId(value);
    if (normalized !== undefined) {
        target[key] = normalized;
    }
}
function buildSnapshotItem(source) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const output = {};
    setStringField(output, "id", source.id);
    setNumberField(output, "quantity", source.quantity);
    setStringField(output, "price_id", (_a = source.price) === null || _a === void 0 ? void 0 : _a.id);
    setStringField(output, "price_nickname", (_b = source.price) === null || _b === void 0 ? void 0 : _b.nickname);
    setStringField(output, "price_currency", (_c = source.price) === null || _c === void 0 ? void 0 : _c.currency);
    setNumberField(output, "price_unit_amount", (_d = source.price) === null || _d === void 0 ? void 0 : _d.unit_amount);
    setStringField(output, "price_interval", (_f = (_e = source.price) === null || _e === void 0 ? void 0 : _e.recurring) === null || _f === void 0 ? void 0 : _f.interval);
    setNumberField(output, "price_interval_count", (_h = (_g = source.price) === null || _g === void 0 ? void 0 : _g.recurring) === null || _h === void 0 ? void 0 : _h.interval_count);
    return output;
}
function normalizeSnapshotData(value) {
    if (typeof value !== "object" || value === null) {
        return null;
    }
    const data = value.data;
    return Array.isArray(data) ? data : null;
}
function normalizeCheckoutMetadata(metadata) {
    if (typeof metadata !== "object" || metadata === null) {
        return undefined;
    }
    return metadata;
}
function normalizeSnapshotItems(value) {
    const snapshotData = normalizeSnapshotData(value);
    if (!snapshotData) {
        return undefined;
    }
    return {
        data: snapshotData.map((item) => buildSnapshotItem(item)),
    };
}
function buildCheckoutSessionEventResponse(payload) {
    var _a;
    const output = {
        id: typeof payload.id === "string" ? payload.id : "",
        created: (_a = normalizeOptionalInteger(payload.created)) !== null && _a !== void 0 ? _a : 0,
    };
    setStringField(output, "status", payload.status);
    setIdField(output, "subscription_id", payload.subscription);
    setIdField(output, "payment_intent_id", payload.payment_intent);
    setIdField(output, "invoice_id", payload.invoice);
    setIdField(output, "customer_id", payload.customer);
    const metadata = normalizeCheckoutMetadata(payload.metadata);
    setStringField(output, "metadata_env", metadata === null || metadata === void 0 ? void 0 : metadata["env"]);
    setStringField(output, "metadata_subscription", metadata === null || metadata === void 0 ? void 0 : metadata["subscription"]);
    return output;
}
